import { useContext } from "react";
import { ConfigContext } from "@/contexts/ConfigProvider";
import type { FooterConfig } from "@/types/FooterConfig";

export function useFooterConfig(): FooterConfig {
  const context = useContext(ConfigContext);

  if (!context) {
    throw new Error("useFooterConfig must be used within a ConfigProvider");
  }

  return context.footer;
}
